module.exports = __webpack_public_path__ + "b8c2ec7513547ca73ed2a241f5de6688.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/elephants2.jpg
// module id = 442
// module chunks = 0